import { render, staticRenderFns } from "./PamRecalculo.vue?vue&type=template&id=123609e2&scoped=true&"
import script from "./PamRecalculo.vue?vue&type=script&lang=js&"
export * from "./PamRecalculo.vue?vue&type=script&lang=js&"
import style0 from "./PamRecalculo.vue?vue&type=style&index=0&id=123609e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123609e2",
  null
  
)

export default component.exports